module.exports = __webpack_public_path__ + "static/u-s-personal-bankruptcy-rate-2017-5-da326e7f7899dba9136ac6e3123c6346.png";